import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { BillingPath } from "v2/pages/billing/BillingPath";
import scraperApi, { ApiError } from "api";
import Toaster from "components/Toaster";
import Modal, { ModalContent } from "components/Modal";


export function ConfirmPaymentSourceSessionModal() {
  const { checkoutId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    if (checkoutId) {
      (async () => {
        try {
          await scraperApi.billing.paymentSources.completeCheckoutSession(checkoutId);

          Toaster.success("Payment Method Added", "Your new payment method has been added successfully.", { toastId: "stripe-add-payment-method-success" });
        } catch (error: any) {
          if (error instanceof ApiError) {
            if (error.error_code === "err_payment_method_setup_failed") {
              if (error.details.failure_code === "payment_method_customer_decline") {
                Toaster.error("Payment Method Error", "You have declined the payment method.", { toastId: "payment-method-setup-failed-toaster" });
              }
            } else {
              // TODO more error handling
              Toaster.error("Payment Method Error", "", { toastId: "payment-method-setup-failed-toaster" });
            }
          }
        } finally {
          timeoutId = setTimeout(() => navigate(BillingPath + "/details"), 3000);
        }
      })();
    } else {
      timeoutId = setTimeout(() => navigate(BillingPath + "/details"), 3000);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    }
  }, [ checkoutId, navigate ]);


  return (
    <Modal headline="Adding Payment Method">
      <ModalContent>
        <div>
          We're finishing up adding your payment method. This usually takes just a few seconds.
        </div>
      </ModalContent>
    </Modal>
  );
}
